import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiBackdrop: Components<CssVarsTheme>['MuiBackdrop'] = {
  styleOverrides: {
    root: {
      backgroundColor: '#777F8E80',
      backdropFilter: 'blur(6px)'
    },
    invisible: {
      backgroundColor: 'transparent',
      backdropFilter: 'none'
    }
  }
};
